import { Box, Stack, Typography } from "@mui/material";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";

/**
 * Shown when the Deep View request succeeded but returned nothing — the brand
 * has no lineage recorded for the selected period.
 */
const DeepViewEmptyState = () => (
  <Stack
    alignItems="center"
    justifyContent="center"
    sx={{ px: 4, py: 8, textAlign: "center" }}
  >
    <Box
      sx={{
        width: 56,
        height: 56,
        borderRadius: "50%",
        backgroundColor: "#F5F5F5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 1.5,
      }}
    >
      <SearchOffOutlinedIcon sx={{ fontSize: 28, color: "#00000061" }} />
    </Box>

    <Typography
      sx={{
        fontSize: "15px",
        fontWeight: 500,
        color: "#000000DE",
        mb: 0.5,
      }}
    >
      No deep view data
    </Typography>

    <Typography
      sx={{
        fontSize: "13px",
        color: "#00000099",
        lineHeight: "20px",
        maxWidth: 340,
      }}
    >
      We could not trace this value for the selected brand and period. Try a
      different date range, or check back once the data has been collected.
    </Typography>
  </Stack>
);

export default DeepViewEmptyState;
